/* トップのメインビジュアル（写真のスライドショー）
   - 1枚目は HTML に入っている。2枚目以降は表示の直前に読み込む（全部を先に読まない）
   - 自動再生は「動きを減らす」設定のとき行わない。操作中・フォーカス中・タブが見えないときは止まる
   - 写真が読み込めない枚数は飛ばし、「01 / 16」の総数も数え直す */
(() => {
  const root = document.querySelector('[data-hero]');
  if (!root) return;
  const frames = Array.from(root.querySelectorAll('[data-frame]'));
  const caps = Array.from(root.querySelectorAll('[data-cap]'));
  const ctl = root.querySelector('[data-ctl]');
  if (frames.length < 2 || !ctl) return;

  const interval = Math.max(3, Number(root.dataset.interval) || 4) * 1000;
  const cur = root.querySelector('[data-cur]');
  const tot = root.querySelector('[data-tot]');
  const live = root.querySelector('[data-live]');
  const playBtn = root.querySelector('[data-play]');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pad = (n) => String(n).padStart(2, '0');

  let index = 0;
  let timer = null;
  let userPaused = reduce.matches;   // 利用者が止めた／動きを減らす設定
  let hold = 0;                      // ホバー・フォーカス・タッチ中の保留
  const bad = new Set();

  const alive = () => frames.map((_, i) => i).filter((i) => !bad.has(i));
  const load = (i) => {
    const img = frames[i].querySelector('img[data-src]');
    if (!img) return;
    img.addEventListener('error', () => markBad(i), { once: true });
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  };
  const next = (i, step) => {
    const a = alive();
    const p = a.indexOf(i);
    if (p < 0) return a[0];
    return a[(p + step + a.length) % a.length];
  };
  function markBad(i) {
    bad.add(i);
    frames[i].classList.add('is-bad');
    caps[i].classList.add('is-bad');
    frames[i].classList.remove('is-on');
    caps[i].classList.remove('is-on');
    if (i === index) go(next(i, 1), false);
    else refresh();
  }
  function refresh() {
    const a = alive();
    tot.textContent = pad(a.length);
    cur.textContent = pad(a.indexOf(index) + 1);
  }
  function go(i, announce) {
    if (i === undefined || i === index && frames[i].classList.contains('is-on')) return;
    load(i);
    frames[index].classList.remove('is-on');
    caps[index].classList.remove('is-on');
    frames[index].setAttribute('aria-hidden', 'true');
    caps[index].setAttribute('aria-hidden', 'true');
    index = i;
    frames[i].classList.add('is-on');
    caps[i].classList.add('is-on');
    frames[i].removeAttribute('aria-hidden');
    caps[i].removeAttribute('aria-hidden');
    refresh();
    load(next(i, 1));              // 次の1枚だけ先に読む
    if (announce && live) {
      const t = caps[i].querySelector('[data-name]');
      live.textContent = `${pad(alive().indexOf(i) + 1)} / ${pad(alive().length)} ${t ? t.textContent : ''}`;
    }
  }
  function schedule() {
    clearTimeout(timer);
    if (userPaused || hold || document.hidden) return;
    timer = setTimeout(() => { go(next(index, 1), false); schedule(); }, interval);
  }
  const setPaused = (p) => {
    userPaused = p;
    playBtn.setAttribute('aria-pressed', String(p));
    playBtn.setAttribute('aria-label', p ? '自動で切り替える' : '自動の切り替えを止める');
    if (live) live.setAttribute('aria-live', p ? 'polite' : 'off');
    schedule();
  };
  const manual = (step) => { go(next(index, step), true); schedule(); };

  // 画面の準備ができるまで操作部は隠しておく（JSなしでは1枚目だけの表示）
  ctl.hidden = false;
  root.classList.add('is-js');
  frames.forEach((f, i) => { if (i) { f.setAttribute('aria-hidden', 'true'); caps[i].setAttribute('aria-hidden', 'true'); } });
  const first = frames[0].querySelector('img');
  if (first) first.addEventListener('error', () => markBad(0), { once: true });
  refresh();
  setPaused(userPaused);

  root.querySelector('[data-prev]').addEventListener('click', () => manual(-1));
  root.querySelector('[data-next]').addEventListener('click', () => manual(1));
  playBtn.addEventListener('click', () => setPaused(!userPaused));

  // 2枚目は読み込みが落ち着いてから先に用意する
  const warm = () => {
    // 1枚目の読み込み失敗は、error より先に起きていたときのためここでも確かめる
    if (first && first.complete && first.naturalWidth === 0 && !bad.has(0)) markBad(0);
    load(next(index, 1));
  };
  if (document.readyState === 'complete') setTimeout(warm, 800);
  else window.addEventListener('load', () => setTimeout(warm, 800), { once: true });

  // 操作中・フォーカス中は切り替えない
  const stage = root.querySelector('[data-stage]');
  stage.addEventListener('mouseenter', () => { hold |= 1; clearTimeout(timer); });
  stage.addEventListener('mouseleave', () => { hold &= ~1; schedule(); });
  stage.addEventListener('focusin', () => { hold |= 2; clearTimeout(timer); });
  stage.addEventListener('focusout', (e) => { if (!stage.contains(e.relatedTarget)) { hold &= ~2; schedule(); } });
  document.addEventListener('visibilitychange', schedule);
  reduce.addEventListener && reduce.addEventListener('change', (e) => { if (e.matches) setPaused(true); });

  // キーボード（左右キー）
  stage.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') { manual(-1); e.preventDefault(); }
    else if (e.key === 'ArrowRight') { manual(1); e.preventDefault(); }
  });

  // スワイプ（縦のスクロールは妨げない）
  const frameBox = root.querySelector('[data-frames]');
  let sx = 0, sy = 0, tracking = false;
  frameBox.addEventListener('touchstart', (e) => {
    if (e.touches.length !== 1) return;
    sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true; hold |= 4; clearTimeout(timer);
  }, { passive: true });
  frameBox.addEventListener('touchend', (e) => {
    hold &= ~4;
    if (tracking) {
      const t = e.changedTouches[0];
      const dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) { manual(dx < 0 ? 1 : -1); tracking = false; return; }
    }
    tracking = false; schedule();
  }, { passive: true });
  frameBox.addEventListener('touchcancel', () => { tracking = false; hold &= ~4; schedule(); }, { passive: true });
})();
